






































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../lib/util'
import AbpBase from '../../lib/abpbase'
import CompanyInformation from '../../store/entities/companyinformation'
@Component
export default class CreateCompanyInformation extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    companyinformation:CompanyInformation=new CompanyInformation();
    
    save(){
        (this.$refs.companyinformationForm as any).validate(async (valid:boolean)=>{
            if(valid){
                await this.$store.dispatch({
                    type:'companyinformation/create',
                    data:this.companyinformation
                });
                (this.$refs.companyinformationForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
            }
        })
    }
   

    cancel(){
        (this.$refs.companyinformationForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    validatePassCheck = (rule:any, value:any, callback:any) => {
        if (!value) {
            callback(new Error(this.L('ConfirmPasswordMsg')));
           
            callback(new Error(this.L('ConfirmPasswordNotMatch')));
        } else {
            callback();
        }
    };
    companyinformationRule={
        
        name:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('CompanyinformationName')),trigger: 'blur'}],
        
    }
}
